type Props = {
  children: React.ReactNode;
};

const BoardGrid = ({ children }: Props) => (
  <div
    className="grid gap-3 content-start pt-0.5"
    style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}
  >
    {children}
  </div>
);

export default BoardGrid;
